import { render, staticRenderFns } from "./OrgLeadsStatsByDayBySource.vue?vue&type=template&id=64adad95&scoped=true&"
import script from "./OrgLeadsStatsByDayBySource.vue?vue&type=script&lang=js&"
export * from "./OrgLeadsStatsByDayBySource.vue?vue&type=script&lang=js&"
import style0 from "./OrgLeadsStatsByDayBySource.vue?vue&type=style&index=0&id=64adad95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64adad95",
  null
  
)

export default component.exports